<div class="imageBox">
  <div class="tags-box animated" [ngClass]="tagsPosition()">
    @for (tag of tags(); track tag) {
      <div class="tag-label {{tag.animationCLass}}"
           [ngClass]="{'show':isTagShown()}"
           [ngStyle]="{'--delay': tag.delay}">{{ tag.title }}
      </div>
    }
  </div>
  <div class="bck">
    <img class="lines-top" [ngSrc]="'assets/img/paper-withclips_shadow-top.png'" alt="" [width]="800" [height]="1250"/>
    <img [ngSrc]="'assets/img/paper-withclips_shadow.png'" alt="" [width]="800" [height]="1250"/>
  </div>
  <div class="image-top-margin"></div>
  <div class="image fade-image" [ngClass]="{'show': currentImageIndex()===1}">
    <img [ngSrc]="prevImage().path" alt="Generated image" [width]="415"
         [height]="415"/>
  </div>
  <div class="image fade-image" [ngClass]="{'show': currentImageIndex()===2}">
    <img [ngSrc]="currentImage().path" alt="Generated image" [width]="415"
         [height]="415"/>
  </div>
  <div class="image-bottom-margin"></div>
  <div class="signature fade-image" [ngClass]="{'show': currentImageIndex()===1}">
    <img [ngSrc]="prevImage().signaturePath" alt="Signature" [width]="264" [height]="64">
  </div>
  <div class="signature fade-image" [ngClass]="{'show': currentImageIndex()===2}">
    <img [ngSrc]="currentImage().signaturePath" alt="Signature" [width]="264" [height]="64">
  </div>
  <div class="image-signature-margin"></div>
  <span class="title">Kunsten at drømme. Et AI-kunstprojekt i samarbejde mellem Pædagogernes Pension og BUPL.</span>

</div>
